import '@/components/helpers/gm-state.types'

const CUSTOMER_UPDATE_PATH = '/apps/returns/api/customer/update'
const REWARDS_CUSTOMER_TAG = 'rewards-account'
const REWARDS_LOGIN_INTENT_KEY = 'rewards-login-intent'
const LOGIN_INTENT_SELECTOR = '[data-rewards-login]'

function hasLoginIntent(): boolean {
  try {
    return localStorage.getItem(REWARDS_LOGIN_INTENT_KEY) === 'true'
  } catch {
    return false
  }
}

function setLoginIntent(): void {
  try {
    localStorage.setItem(REWARDS_LOGIN_INTENT_KEY, 'true')
  } catch {
    /* ignore */
  }
}

function clearLoginIntent(): void {
  try {
    localStorage.removeItem(REWARDS_LOGIN_INTENT_KEY)
  } catch {
    /* ignore */
  }
}

async function addRewardsTag(): Promise<boolean> {
  if (typeof window === 'undefined') return false

  try {
    const res = await fetch(`${window.location.origin}${CUSTOMER_UPDATE_PATH}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'addTag', tag: REWARDS_CUSTOMER_TAG }),
      credentials: 'same-origin'
    })
    return res.ok
  } catch {
    return false
  }
}

export function trackRewardsLoginIntent(): void {
  if (typeof document === 'undefined') return

  const attach = () => {
    document.querySelectorAll<HTMLElement>(LOGIN_INTENT_SELECTOR).forEach((el) => {
      el.addEventListener('click', setLoginIntent)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach, { once: true })
  } else {
    attach()
  }
}

export function applyRewardsTagOnReturn(): void {
  const customerId = typeof window !== 'undefined' ? window.globals?.customer?.id : null

  if (!customerId || !hasLoginIntent()) return

  addRewardsTag().then((ok) => {
    if (ok) clearLoginIntent()
  })
}
